import {StylesT} from "~utils/utils";

const styles: StylesT = {
    dataGridWrapper: {
        height: 600,
    },
};
export default styles;
